const backendApi = process.env.BACKEND_API;

module.exports = async function (file) {
  if (!file) return;

  const res = await fetch(backendApi + "/frontend/parseQrCode", {
    headers: {
      Authorization: `Bearer ${process.env.STRAPI_TOKEN}`,
    },
    method: "POST",
    body: file,
  });

  const { data } = await res.json();

  return data;
};
